import Vue from 'vue'
import SvgIcon from '@/components/IconSvg.vue'
Vue.component('icon-svg',SvgIcon);

const req = require.context('@/icons/svg', false, /\.svg$/);
const requireAll = requireContext => {
  requireContext.keys().map(requireContext)
};
requireAll(req);